import { isGermanNumberFormat } from './numberFormat';

const formatters = {
  en: {
    SC: Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
    GC: Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }),
  },
  de: {
    SC: Intl.NumberFormat('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
    GC: Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }),
  },
};

export default function animateValue(
  el: HTMLElement,
  start: number,
  end: number,
  duration: number,
  coinType: 'SC' | 'GC' = 'SC',
  // wsc cash-balance only: update the text node in place. Replacing it (innerHTML) detaches the node
  // React tracks, so a later re-render/unmount throws "removeChild: not a child" (the SC-lobby cash
  // crash). Default false keeps the original innerHTML behavior for every non-cash caller — untouched.
  inPlace = false,
): void {
  let startTimestamp: number | null = null;
  const step = (timestamp: number) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    const text = formatters[isGermanNumberFormat() ? 'de' : 'en'][coinType].format(progress * (end - start) + start);
    if (inPlace && el.firstChild && el.firstChild.nodeType === Node.TEXT_NODE) {
      el.firstChild.nodeValue = text;
    } else {
      el.innerHTML = text;
    }
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
}
